import Disclosure from "../../utils/Disclosure.js";

class SupportBlock {
    constructor(element, options = {}) {
        this.el = element;
        this.items = this.el.querySelectorAll(".support-block__disclosure");
        this.disclosureItems = [];
        this.options = {
            singleSupportBlockOpen: true, // Only one support item can be open at a time.
            ...options,
        };

        // Bail early - no support items.
        if (this.items.length < 1) {
            return;
        }

        this.init();
    }

    init() {
        this.items.forEach((item) => {
            const supportDisclosure = new Disclosure(item, {
                allowClose: false,
                collapseOnOtherElementsExpand: item.parentNode.childNodes,
            });

            this.disclosureItems.push(supportDisclosure);
        });

        this.handleCustomDonationInput();
    }

    handleCustomDonationInput() {
        const customDonationInput = this.el.querySelector(
            "[data-custom-donation-input]",
        );
        const donationAmountRadios = this.el.querySelectorAll(
            "input[name='donation-amount']",
        );

        if (customDonationInput) {
            customDonationInput.addEventListener("input", () => {
                donationAmountRadios.forEach((radio) => {
                    radio.checked = false;
                });
            });
        }

        if (donationAmountRadios) {
            donationAmountRadios.forEach((radio) => {
                radio.addEventListener("change", () => {
                    customDonationInput.value = "";
                });
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const supportElements = document.querySelectorAll(".support-block");

    supportElements.forEach((element) => {
        new SupportBlock(element);
    });
});
